import { getNetworksList } from '@/api/trading-networks'
import { getDetailsList } from '@/api/detailing'
import { getReturnPointsList } from '@/api/return-points'
import { getReturnStatusesList } from '@/api/return-statuses'
import { getAllSuppliersList } from '@/api/suppliers'
import { getRegionsList } from '@/api/regions'
import headersDataMixin from './headers-data'

import { arrayToOptions } from '@/utils/get-options'

export default {
  mixins: [headersDataMixin],

  data() {
    return {
      selectsOptions: {}
    }
  },

  computed: {
    headerFiltersData() {
      return [
        {
          filter: 'network',
          name: 'network_id',
          callback: getNetworksList,
          type: 'list',
          access: Object.values(this.$constants.users)
        },
        {
          filter: 'status_detail',
          name: 'status_detail_id',
          callback: getDetailsList,
          type: 'autocomplete',
          access: Object.values(this.$constants.users)
        },
        {
          filter: 'return_point',
          name: 'return_point_id',
          callback: getReturnPointsList,
          access: Object.values(this.$constants.users)
        },
        {
          filter: 'status',
          name: 'status_id',
          callback: this.$apiMethods.x5.statusesList,
          access: Object.values(this.$constants.users)
        },
        {
          filter: 'return_status',
          name: 'return_status_id',
          callback: getReturnStatusesList,
          access: Object.values(this.$constants.users)
        },
        {
          filter: 'supplier',
          name: 'supplier_id',
          callback: getAllSuppliersList,
          access: Object.values(this.$constants.users)
        },
        {
          filter: 'store',
          name: 'store_id',
          callback: this.$apiMethods.stores.allList,
          access: Object.values(this.$constants.users)
        },
        {
          filter: 'region',
          name: 'region_id',
          callback: getRegionsList,
          access: Object.values(this.$constants.users)
        },
        {
          filter: 'district',
          name: 'district_id',
          callback: this.$apiMethods.districts.list,
          access: Object.values(this.$constants.users)
        }
      ].filter(({ access }) => access.includes(this.$store.user.role))
    }
  },

  methods: {
    loadSelectsData() {
      this.isDataLoading = true

      Promise.all([
        this.$apiMethods.stores.allList(),
        getReturnStatusesList.bind(this)(),
        getDetailsList.bind(this)()
      ])
        .then(([stores, returnStatuses, details]) => {
          this.selectsOptions = {
            stores: stores.items,
            returnStatuses: returnStatuses.items,
            details: details.items
          }

          this.loadData(this.filtersQuery)
        })
        .catch(() => {
          window.snackbar('Прошла ошибка во время инициализации таблицы, попробуйте перезагрузить страницу', 'error')
          this.disableLoadingIndicator()
        })
    },

    initFilters() {
      this.headerFiltersData.forEach(filter => {
        this.setFilter(filter)
      })
    },

    setFilter({ filter, name, callback, type = 'multiple-autocomplete' }) {
      const index = this.headerData.findIndex(item => item.value === filter)

      if (index < 0) {
        return
      }

      this.headerData[index].customFilter.name = name

      if (type === 'multiple-autocomplete') {
        this.headerData[index].customFilter.callback = callback.bind(this)
      } else if (type === 'list' || type === 'autocomplete') {
        callback.bind(this)().then(({ items }) => {
          if (!this.headerData[index]) {
            return
          }

          this.headerData[index].customFilter.options = items && arrayToOptions(
            { array: items, keyName: 'value', valueName: 'text' }
          ) || []
        })
      }
    }
  }
}
